import { type Common } from './common.js';
import type * as Allergy from './models/allergy/index.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  // previsit app endpoints
  async findAll(): Promise<Allergy.Allergy[]> {
    const url = this.common.constructPath(`/patient-previsit/allergies`);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<Allergy.Allergy> {
    const url = this.common.constructPath(`/patient-previsit/allergies/${id}`);
    return await this.common.getJSON(url);
  }

  async create(values: Allergy.CreateValues): Promise<Allergy.Allergy> {
    const url = this.common.constructPath(`/patient-previsit/allergies`);
    return await this.common.postJSON(url, values);
  }

  async upsert(values: Omit<Allergy.CreateValues, 'source'>): Promise<Allergy.Allergy> {
    const url = this.common.constructPath(`/patient-previsit/allergies`);
    return await this.common.putJSON(url, values);
  }

  async update(id: string, values: Allergy.UpdateValues): Promise<Allergy.Allergy> {
    const url = this.common.constructPath(`/patient-previsit/allergies/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<void> {
    const url = this.common.constructPath(`/patient-previsit/allergies/${id}`);
    return await this.common.deleteJSON(url);
  }
}
